import MyPTApp from './mypt-app';

export default MyPTApp;
